import { useAddEventListener } from 'hooks/common';

export const useKeyboardByForm = <
  T extends (Window & typeof globalThis) | Document | HTMLElement | null = Document,
>(
  target: T,
  onSubmit: VoidFunction,
  deps: unknown[] = [],
): void => {
  const onFormChange = (event: KeyboardEvent) => {
    switch (event.key) {
      case 'Enter':
        if (!event.shiftKey) onSubmit();
        break;
      default:
        break;
    }
  };

  useAddEventListener('keydown', onFormChange, deps, target);
};
